export class MicroappNotificationsListFilter{
    general: string;
    send: string;
}